import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export function useAppToast() {
  const toast = useToast();

  function showToast(title, text, variant, icon = "InfoIcon") {
    toast({
      component: ToastificationContent,
      props: {
        title,
        text,
        variant,
        icon,
      },
    });
  }

  return {
    showToast,
  };
}
